export default __webpack_public_path__ + "static/media/bar-tachograph-cards.8782012b.svg";